// extracted by mini-css-extract-plugin
module.exports = {"cls1":"using-typescript-Article-module--cls1--XyFCb","cls2":"using-typescript-Article-module--cls2--p4ZXd using-typescript-Article-module--cls1--XyFCb"};